import type { WorkspaceMode } from '@/lib/workspace-mode';

export type ExploreTopTab = 'material' | 'template' | 'my-assets' | 'create';

/** Global rail destinations must be identical from every workspace surface. */
export function getExploreHref(tab: ExploreTopTab): string {
  if (tab === 'template') return '/template-library';
  if (tab === 'create') return '/explore?tab=create';
  if (tab === 'my-assets') return '/explore?tab=assets';
  return '/explore';
}

/** Existing projects restore their own view; creation flows may explicitly request one. */
export function getExploreProjectHref(projectId: string, requestedView?: WorkspaceMode): string {
  return `/p/${encodeURIComponent(projectId)}${requestedView ? `?view=${requestedView}` : ''}`;
}
